<template>
  <div class="AppBar">
    <img src="@/assets/logo.svg" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.AppBar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 20px;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, .7);
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px,
    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
}
img{
    width: 130px;
}
</style>
